import React from 'react';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import useSelector from '../../../hooks/useSelector';
import SMASwitch from './SMASwitch';

const MarketSMASwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
}> = ({ wrapAnalytics }) => {
  const dispatch = useDispatch();
  const { showMarketSMA, marketSMAIntervals } = useSelector(
    state => state.preference
  );
  return (
    <SMASwitch
      wrapAnalytics={wrapAnalytics}
      show={showMarketSMA}
      intervals={marketSMAIntervals}
      setShow={show =>
        dispatch(preferenceActions.setPriceViewerMarketSMA(show))
      }
      setNewIntervals={(newIntervals: number[]) =>
        dispatch(
          preferenceActions.setPriceViewerMarketSMAInterval(newIntervals)
        )
      }
      analyticKey="MarketSMA"
    />
  );
};

export default MarketSMASwitch;
